export default {
  sinceJobStart: 'Seit Chargenstart',
  sinceFirstInBand: 'Seit erstem Wert im Band',
};
